export const UNLOCK_REFRESH_LABEL = 'Unlock/Refresh';
export const TALK_TO_US_HEADER = 'Contact Us';
export const TALK_TO_US_CONTENT = 'Contact your dedicated Relationship Manager';
export const DEFAULT_COUNTRY_CODE = '+91';
